import myw from 'myWorld-client';

myw.applicationDefinition = {
    Application: myw.Application,
    GeoMapControl: myw.GeoMapControl,
    plugins: {
        mousePositionControl: [
            myw.MousePositionPlugin,
            { enabled: false, position: 'bottomleft', decimalPlaces: 5 }
        ],

        mapViewStack: myw.MapViewStackPlugin,
        userLocation: myw.UserLocationPlugin,
        internals: myw.InternalsPlugin,

        resultsGrid: myw.ResultsGridPlugin,
        minimap: [myw.MinimapPlugin, { enabled: false }],
        magnifyingGlass: [myw.MagnifyingGlassPlugin, { enabled: false }],
        zoomLevelControl: [myw.ZoomLevelControlPlugin, { enabled: false }],
        snapping: myw.SnappingPlugin,

        //Native App specific plugins
        syncUpload: myw.SyncUploadPlugin,
        syncDownload: myw.SyncDownloadPlugin,
        softKeyboardInput: myw.SoftKeyboardInputPlugin        
    },

    mapContextMenuActions: [
        'copyCoordinate',
        'clearSelection',
        'multipleSelect',
        'refresh',
        '-',
        'zoomLevelControl.toggle',
        'mousePositionControl.toggle',
        'minimap.toggle'
    ],
    displayUnits: {
        length: 'm'
    },

    layouts: {
        phone: {
            layoutClass: myw.Layout
        },
        desktop: {
            layoutClass: myw.Layout
        },               
        embedded_map: {
            layoutClass: myw.Layout
        }
    }
};
